/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable react/no-danger */
import React, { FC, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useDidMount } from '@mtsbank/ui-kit'
import { TemporarilyUnavailablePageView } from '@views/error-page/@x/tsp-page'
import { TspPaymentStep } from '@entities/payment'
import { PayeeWithCustomParamsType, useCyberStore } from '@entities/tsp'
import { ServerOption } from '@entities/server'
import { FetchHintsResponseType } from '@entities/hint'
import { servicesLoadedCyberGtm } from '@shared/lib/gtm'
import { Payee } from '@root/api/ump-catalog-manager'
import { useFromOtp } from '../lib/useFromOtp'
import UnreleasedServicePageView from './UnreleasedServicePageView'
import OldTspFormPageView from './OldTspFormPageView'
import OtpPcekPageView from './OtpPcekPageView'

interface OldTspPageViewProps {
  h1: string
  payee: PayeeWithCustomParamsType
  linkedTsp: PayeeWithCustomParamsType
  countryVouchers: { country: string; icon: string }[]
  denominationsByCountry: Record<string, Payee[]>
  providerURL: string
  servers: ServerOption[]
  hints: FetchHintsResponseType
}

const OldTspPageView: FC<OldTspPageViewProps> = ({
  h1,
  payee,
  linkedTsp,
  countryVouchers,
  denominationsByCountry,
  providerURL,
  servers,
  hints,
}) => {
  const { setIsPromocodeActivated, step } = useCyberStore()
  const router = useRouter()

  useFromOtp()

  useDidMount(() => {
    servicesLoadedCyberGtm(payee?.providerName)
  })

  useEffect(() => {
    if (router.query?.id !== 'steam') {
      setIsPromocodeActivated(false)
    }
  }, [router.query?.id])

  if (payee.customParams?.isDisabled) {
    return <UnreleasedServicePageView />
  }

  return {
    [TspPaymentStep.SERVICES_FORM]: (
      <OldTspFormPageView
        payee={payee}
        h1={h1}
        linkedTsp={linkedTsp}
        countryVouchers={countryVouchers}
        denominationsByCountry={denominationsByCountry}
        providerURL={providerURL}
        servers={servers}
        hints={hints}
      />
    ),
    [TspPaymentStep.NOT_TCP]: <TemporarilyUnavailablePageView />,
    // @ts-ignore
    [TspPaymentStep.PAYMENT_OTP]: <OtpPcekPageView />,
  }[step]
}

export default OldTspPageView
